var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHome = function SvgHome(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5481 2.57712C11.3369 1.74635 12.663 1.74635 13.4519 2.57712L21.4519 11.0022C21.8038 11.3728 22 11.864 22 12.3745L22 19.9586C22 21.0607 21.1046 21.954 20 21.954H15C13.8954 21.954 13 21.0607 13 19.9586L13 15.4689H11L11 19.9586C11 21.0607 10.1046 21.954 9 21.954H4C2.89543 21.954 2 21.0607 2 19.9586L2 12.3745C2 11.864 2.19615 11.3728 2.54809 11.0022L10.5481 2.57712ZM20 12.3745L12 3.94945L4 12.3745L4 19.9586H9L9 15.4689C9 14.3669 9.89543 13.4735 11 13.4735H13C14.1046 13.4735 15 14.3669 15 15.4689L15 19.9586H20L20 12.3745Z",
    fill: "black"
  })));
};
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "static/media/home.d3ae463f.svg";